import {useComponent} from '../../component-library';
import {TwoColumnTableCell} from './two-column-table-cell';
import {Table} from './table';

import React from 'react';
import {ExternallyRenderedDisclaimerReference} from '../externally-rendered-disclaimer-reference';

export interface EfficiencyClassTableProps {
  readonly label: string;
  readonly value: string;
  readonly disclaimer?: string;
  readonly disclaimerReferenceLabelTranslation: string | undefined;
  readonly closeButtonLabel: string;
}

export function EfficiencyClassTable({
  label,
  value,
  disclaimer,
  disclaimerReferenceLabelTranslation,
  closeButtonLabel,
}: EfficiencyClassTableProps): JSX.Element {
  const Text = useComponent('Text');

  return (
    <Table>
      <tr>
        <TwoColumnTableCell isTableHeader={true}>
          <Text variant="label" tag="span">
            {label}
          </Text>
        </TwoColumnTableCell>
        <TwoColumnTableCell isTableHeader={false}>
          <Text variant="label" tag="span" bold whiteSpace="nowrap">
            {value}
            {disclaimer && (
              <ExternallyRenderedDisclaimerReference
                text={disclaimer}
                disclaimerReferenceLabelTranslation={
                  disclaimerReferenceLabelTranslation
                }
                closeButtonLabel={closeButtonLabel}
              />
            )}
          </Text>
        </TwoColumnTableCell>
      </tr>
    </Table>
  );
}
